import './bootstrapApp';
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';

import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

import launchDarklyConfig from './config/launch-darkly-config';
import { ReactApp } from './ReactApp';

(async () => {
  const LDProvider = await asyncWithLDProvider(launchDarklyConfig);

  createRoot(document.getElementById('root') as HTMLElement).render(
    <StrictMode>
      <ReactApp LDProvider={LDProvider} />
    </StrictMode>
  );
})();
